AnalyticsConfig.$inject = ['AnalyticsProvider'];

function AnalyticsConfig(AnalyticsProvider) {
    // Add configuration code as desired
    AnalyticsProvider
        .setAccount('UA-91828971-1', {
            trackEvent: true
        })
        //.enterDebugMode(false) //stage !== 'prod')
        .trackPages(false)
        .trackUrlParams(false)
        .trackPrefix(window.location.pathname)
        .setPageEvent('$stateChangeSuccess')
        .readFromRoute(false)
        .logAllCalls(false);
}

export default AnalyticsConfig;